import { useMutation, useQuery } from '@apollo/client'
import { ErrorComponent, NotFound, ProgressSpinner } from '@medical/components'
import EmailConfirmationForm from '@medical/components/Forms/EmailConfirmationForm/EmailConfirmationForm'
import Auth from '@medical/middleware/auth'
import { useCustom } from '@medical/provider/context'
import HomeRedirect from '@medical/routes/HomeRedirect'
import Router from '@medical/routes/router'
import queryString from 'query-string'
import React from 'react'

import {
  STAFF_CHANGE_RESET_PASSWORD,
  STAFF_CHECK_RESET_PASSWORD_NUMBER,
} from './StaffResetPassword.graphql'

const StaffResetPassword = ({ history, location: { search } }) => {
  const { resetPasswordNumber } = queryString.parse(search)
  const [{ i18n, popup }] = useCustom()
  const [changeResetPassword] = useMutation(STAFF_CHANGE_RESET_PASSWORD)
  const { loading, error, data } = useQuery(STAFF_CHECK_RESET_PASSWORD_NUMBER, {
    variables: {
      resetPasswordNumber,
    },
  })

  if (Auth.getToken()) return <HomeRedirect />
  if (loading) return <ProgressSpinner />
  if (error) return <ErrorComponent />
  if (!data.staffCheckPasswordNumber) return <NotFound />

  const onSubmit = async ({ newPassword }, { setSubmitting, resetForm }) => {
    try {
      await changeResetPassword({
        variables: {
          resetPasswordNumber,
          newPassword,
        },
      })
      setSubmitting(false)
      resetForm()
      popup.success(i18n.t('main.changePassword.submissionSuccess'))
      history.push({
        pathname: Router.staffLogin,
      })
    } catch (error) {
      popup.error(error)
      setSubmitting(false)
    }
  }

  return <EmailConfirmationForm onSubmit={onSubmit} isResetPassword />
}

export default StaffResetPassword
